import React from 'react'
import { useIntl } from 'react-intl'
import { twMerge } from 'tailwind-merge'
import { CustomLinkComponent, DynamicTag } from 'msp-components'

import translations from './AccountOverviewPrivacySettings.constants'
import * as S from './AccountOverviewPrivacySettings.styles'

export type AccountOverviewPrivacySettingsProps = {
  className?: string
}

const AccountOverviewPrivacySettings = ({
  className = ''
}: AccountOverviewPrivacySettingsProps) => {
  const { formatMessage } = useIntl()
  const pageLink = '/account/data-sharing'

  return (
    <div className={twMerge(S.MainWrapper, className)}>
      <DynamicTag
        componentTagName='Headline'
        tag='h3'
        tagStyle='h6'
        className={S.Headline}
      >
        {formatMessage(translations.headline)}
      </DynamicTag>
      <div className={S.ListWrapper}>
        <div className={S.ListItem}>{formatMessage(translations.text)}</div>
      </div>
      <CustomLinkComponent href={pageLink} className={S.Link}>
        {formatMessage(translations.headline)}
      </CustomLinkComponent>
    </div>
  )
}

export default AccountOverviewPrivacySettings
